import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
declare const initComposerEmbedManager: any;
@Component({
  selector: 'app-generaloverview-page',
  templateUrl: './generaloverview.component.html',
  styleUrls: ['./generaloverview.component.scss']
})
export class GeneraloverviewComponent implements OnInit {
  animate404: boolean = false;
  message: string;

  constructor(
    private route: ActivatedRoute
  ) {

  }

  ngOnInit() {
    //this.message = "test error message";
    this.EmbedDashboard("6295e010e574e21796bae9a5");
    //setTimeout(() => {this.animate404 = true;},1000);
  }

  EmbedDashboard(dashboardid: string) {
    const getEmbedManagerPromise =
      initComposerEmbedManager({
        initialToken: '0ac99ac8-307c-4640-b372-5cff1af21e11' // tokenValue is provided by the Trusted Access API
      });

    getEmbedManagerPromise.then((embedManager: any) => {
      embedManager.createComponent('dashboard',
        {
          dashboardId: dashboardid, // dashboard id
          //<property>,... // set of properties
        }
      ).then((dashboard: any) => dashboard.render(
        document.getElementById("embedDash"), // htmlElement
        { width: '100%', height: '100%' }
      ))
    });

  }

}
